'use strict';
import angular from 'angular';
import moment from 'moment';

export default class MainController {
  /*@ngInject*/
  constructor($stateParams, $http, $state, $scope, $location, $timeout, Borne, toastr) {
    var vm = this;
    vm.loading = true;
    vm.iteration = 0;
    vm.scanable = true;
    vm.electron = window.electron;
    window.screen = 'main';

    if(vm.electron) {
      Borne.Config = JSON.parse(fs.readFileSync('./config.json', 'utf-8'));
      if(!Borne.Config.posteId) {
        vm.goToAdmin();
      }
    }

    vm.openBadge = function(){
      $('#badge').modal('show');
    }

    vm.openQrcode = function(){
      $('#qrCode').modal('show');
    }

    vm.goToAdmin = function(){
      $location.path('/borne/admin');
    }

    vm.openAdmin = function(){
      vm.iteration ++
      if(vm.iteration == 3) {
        $location.path('/borne/admin');
      }
    }

    if(!Borne.Poste) {
      Borne.load($stateParams.id).then(function () {
        Borne.Poste.Categories = _.filter(Borne.Poste.Categories, 'active');
        vm.borne = Borne.Poste;
        vm.langues = _(vm.borne.availableLanguages).flatMap('dictionnary.main').value();
        vm.loading = false;
        $scope.$apply();
      })
    } else {
        vm.borne = Borne.Poste;
        vm.langues = _(vm.borne.availableLanguages).flatMap('dictionnary.main').value();
        vm.loading = false;
    }
    $('.modal-backdrop').hide();

    if(vm.electron){
      codebarReader.removeAllListeners();
      codebarReader.on('data', function(data){
        var barcode = data.toString().trim();
        if(window.screen == 'main' && vm.scanable){
          //Badge else QRCode
          if(RegExp('^[a-z0-9]{8}$').test(barcode)) {
            vm.scanable = false;
            vm.loading = true;
            $http.get('/api/badges/fetchSmallId/' + barcode).then(function(resp){
              vm.loading = false;
              Borne.Poste.Session.collecte = resp.data.session.collecte;
              Borne.Poste.Session.badge = resp.data;
              if(!_.find(Borne.Poste.Categories, ['_id', Borne.Poste.Session.badge.session.category._id])) {
                vm.scanable = true;
                return toastr.error('Badge not available here.', 'Invalid place');
              }
              Borne.Poste.Session.scanned = true;
              if(moment(resp.data.expiryDate).toDate() > moment().toDate()) {
                // Borne.Poste.Session.scanned = true
              } else {
                Borne.Poste.Session.expired = true;
              }
              Borne.Poste.selectedCategorie = _.find(Borne.Poste.Categories, ['_id', Borne.Poste.Session.badge.session.category._id])
              Borne.Poste.Session.contacts = _.filter(Borne.Poste.contacts, function (contact) {
                return (Borne.Poste.selectedCategorie.contacts.includes(contact._id));
              })
              Borne.Poste.users = Borne.Poste.selectedCategorie.Users;
              _.map(Borne.Poste.Site.Users, function(user){
                if(!_.map(Borne.Poste.users, '_id').includes(user._id) && user.Categories.length == 0) Borne.Poste.users.push(user);
              })
              $location.path('/borne_langues/' + Borne.Poste._id);
            }).catch((err) => {
              vm.scanable = true;
              vm.loading = false;
              toastr.error('Badge not available here.', 'Invalid place');
            })
          } else if(RegExp('^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$')) {
            $http.get('/api/qr-codes/' + barcode).then(function(resp){
              barcode = JSON.stringify(resp.data.data);
              if(!_.find(Borne.Poste.Categories, ['_id', JSON.parse(barcode).session.category._id])) return toastr.error('Badge not available here.', 'Invalid place');
              vm.scanable = false;
              vm.loading = false;
              Borne.Poste.Session.collecte = JSON.parse(barcode);
              moment(JSON.parse(barcode).expiryDate, 'DD/MM/YYYY H:mm').toDate() > moment().toDate() ? Borne.Poste.Session.scanned = true : Borne.Poste.Session.scanned = false;
              Borne.Poste.selectedCategorie = _.find(Borne.Poste.Categories, ['_id', JSON.parse(barcode).session.category._id])
              Borne.Poste.Session.contacts = _.filter(Borne.Poste.contacts, function (contact) {
                return (Borne.Poste.selectedCategorie.contacts.includes(contact._id));
              })
              Borne.Poste.users = Borne.Poste.selectedCategorie.Users;
              _.map(Borne.Poste.Site.Users, function(user){
                if(!_.map(Borne.Poste.users, '_id').includes(user._id) && user.Categories.length == 0) Borne.Poste.users.push(user);
              })
              var langueSelected;
              if(_.find(Borne.Poste.availableLanguages, ["id", Borne.Poste.Session.collecte.session.langue])) langueSelected = _.find(Borne.Poste.availableLanguages, ["id", Borne.Poste.Session.collecte.session.langue])
              else Borne.Poste.availableLanguages[0];
              Borne.changeLanguage(langueSelected);
              // $scope.$apply();
              $('#explainQrCodeModal').modal("show");
              $timeout(() => {
                $location.path('/borne_collecte/' + Borne.Poste.selectedCategorie._id+ '/' + Borne.Poste._id);
                $scope.$apply();
              }, 3000)
            })
          } else if(typeof JSON.parse(barcode) =='object'){
            if(!_.find(Borne.Poste.Categories, ['_id', JSON.parse(barcode).session.category._id])) return toastr.error('Badge not available here.', 'Invalid place');
            vm.scanable = false;
            vm.loading = false;
            Borne.Poste.Session.collecte = JSON.parse(barcode);
            moment(JSON.parse(barcode).expiryDate, 'DD/MM/YYYY H:mm').toDate() > moment().toDate() ? Borne.Poste.Session.scanned = true : Borne.Poste.Session.scanned = false;
            Borne.Poste.selectedCategorie = _.find(Borne.Poste.Categories, ['_id', JSON.parse(barcode).session.category._id])
            Borne.Poste.Session.contacts = _.filter(Borne.Poste.contacts, function (contact) {
              return (Borne.Poste.selectedCategorie.contacts.includes(contact._id));
            })
            Borne.Poste.users = Borne.Poste.selectedCategorie.Users;
            _.map(Borne.Poste.Site.Users, function(user){
              if(!_.map(Borne.Poste.users, '_id').includes(user._id) && user.Categories.length == 0) Borne.Poste.users.push(user);
            })
            var langueSelected;
            if(_.find(Borne.Poste.availableLanguages, ["id", Borne.Poste.Session.collecte.session.langue])) langueSelected = _.find(Borne.Poste.availableLanguages, ["id", Borne.Poste.Session.collecte.session.langue])
            else Borne.Poste.availableLanguages[0];
            Borne.changeLanguage(langueSelected);
            $scope.$apply();
            $('#explainQrCodeModal').modal("show");
            $timeout(() => {
              $location.path('/borne_collecte/' + Borne.Poste.selectedCategorie._id+ '/' + Borne.Poste._id);
              $scope.$apply();
            }, 3000)
          } else {
            toastr.error('Please, be sure you scanned the good QRcode/badge', 'Invalid format');
            vm.loading = false;
          }
        }
      })

      window.onbeforeunload = function(event)
      {
          codebarReader.close();
      };
    }

    vm.goToCatagories = function(){
      Borne.startRecord();
      setTimeout(function(){
        $scope.$apply();
      },250)
      $location.path('/borne_categories/' + $stateParams.id);
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/borne/main/main.controller.js